import { z } from 'zod';
/** Tamaño de página máximo (docs/migration/09 §4). */
export const MAX_PAGE_SIZE = 100;
/** Tamaño de página por defecto. */
export const DEFAULT_PAGE_SIZE = 25;
/** Página máxima admitida: evita desplazamientos absurdos en `OFFSET`. */
export const MAX_PAGE = 1_000_000;
/** Entero positivo en query string: solo dígitos, sin signo, decimales, espacios ni notación científica. */
const positiveIntegerParam = (max) => z
    .string()
    .regex(/^[1-9][0-9]{0,8}$/)
    .transform(Number)
    .pipe(z.int().min(1).max(max));
/**
 * Campos de paginación `?page=1&pageSize=25`. Se exporta la forma para que cada endpoint
 * la combine con sus filtros explícitos en un objeto estricto propio.
 */
export const paginationQueryShape = {
    page: positiveIntegerParam(MAX_PAGE).default(1),
    pageSize: positiveIntegerParam(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
};
/** Query de paginación estricta: `page >= 1` y `1 <= pageSize <= 100`; rechaza parámetros desconocidos. */
export const PaginationQuerySchema = z.strictObject(paginationQueryShape);
/** Respuesta paginada reutilizable: `{ items, page, pageSize, total }`. */
export function paginatedResponseSchema(item) {
    return z.strictObject({
        items: z.array(item).max(MAX_PAGE_SIZE),
        page: z.int().min(1).max(MAX_PAGE),
        pageSize: z.int().min(1).max(MAX_PAGE_SIZE),
        total: z.int().min(0),
    });
}
//# sourceMappingURL=pagination.js.map